<template>
    <section class="hero-banner">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h1 class="display-4 fw-bold mb-4">Profesjonalna obsługa księgowa dla Twojej firmy</h1>
                    <p class="lead mb-4">Selam Rachunkowość to doświadczone biuro rachunkowe oferujące kompleksowe
                        usługi
                        księgowe, podatkowe i kadrowo-płacowe.</p>
                    <div class="d-flex flex-wrap gap-2">
                        <router-link to="/oferta" class="btn btn-primary btn-lg">Nasza oferta</router-link>
                        <router-link to="/kontakt" class="btn btn-outline-secondary btn-lg">Skontaktuj się</router-link>
                    </div>
                </div>
                <div class="col-lg-6 d-none d-lg-block">
                    <img src="@/assets/piona.jpg" alt="Usługi księgowe" class="img-fluid">
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'HeroBanner'
}
</script>

<style lang="scss" scoped>
.hero-banner {
    padding: 6rem 0;
    background: linear-gradient(to right, #f8f9fa, #e9ecef);

    h1 {
        color: var(--primary-color);
    }

    .lead {
        color: #6c757d;
    }
}
</style>